import Swiper from "swiper";
import { Navigation, FreeMode } from "swiper/modules";
// eslint-disable-next-line import/extensions
import "swiper/css";

import "./find-the-canvas-section.scss";

const TABS_CONTAINER_SELECTOR = ".js-jiffytransfers-landing-v2-find-the-canvas-tabs";
const TAB_CONTENT_SELECTOR = ".js-jiffytransfers-landing-v2-find-the-canvas-content";
const TAB_SELECTOR = ".js-jiffytransfers-landing-v2-find-the-canvas-tab";

const TAB_ACTIVE_CLASS = "jiffytransfers-landing-v2-find-the-canvas-section__tab--active";
const TAB_CONTENT_ACTIVE_CLASS =
  "jiffytransfers-landing-v2-find-the-canvas-section__tabs-content--active";

const $getTabs = () => document.querySelectorAll(TAB_SELECTOR);
const $getTabContents = () => document.querySelectorAll(TAB_CONTENT_SELECTOR);

const initTabSwiper = () =>
  new Swiper(TABS_CONTAINER_SELECTOR, {
    modules: [Navigation, FreeMode],
    loop: false,
    centeredSlides: false,
    slidesPerView: "auto",
    freeMode: true
  });

const initTabContentSwiper = () =>
  new Swiper(TAB_CONTENT_SELECTOR, {
    modules: [Navigation],
    loop: false,
    centeredSlides: false,
    slidesPerView: "auto"
  });

const setActiveTabContent = $activeTab => {
  const $tabContents = Array.from($getTabContents());
  const tabId = $activeTab.getAttribute("data-tab");
  const tabContent$ = $tabContents.find(
    tabContent => tabContent.getAttribute("data-tab") === tabId
  );
  $tabContents.forEach(tabContent => tabContent.classList.remove(TAB_CONTENT_ACTIVE_CLASS));
  if (tabId && tabContent$) {
    tabContent$.classList.add(TAB_CONTENT_ACTIVE_CLASS);
  }
};

const setActiveTab = $activeTab => {
  const $tabs = $getTabs();
  $tabs.forEach(tab => tab.parentNode.classList.remove(TAB_ACTIVE_CLASS));
  $activeTab.parentNode.classList.add(TAB_ACTIVE_CLASS);
};

const initTabs = () => {
  initTabSwiper();

  const $tabs = $getTabs();
  $tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      setActiveTab(tab);
      setActiveTabContent(tab);
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initTabs();
  initTabContentSwiper();
});
